import { NavigationProviderStateType, NavOptionType } from "./type";
import { Location } from "history";
import { ALL_FILTER_KEY } from "shared/utils/constants";

export function setItemActiveByKey(navOption: NavOptionType, key: string) {
  navOption.active = navOption.key === key;
  navOption.child?.forEach(item => {
    setItemActiveByKey(item, key);
  });
}

export function getParentOptionIndexInHistory(optionToAdd: NavOptionType, history: Array<NavOptionType>) {
  if (!history || history.length === 0) {
    return -1;
  }
  return history.findIndex(item => isKeyExistInOption(item, optionToAdd.key));
}

function isKeyExistInOption(option: NavOptionType, key: string): boolean {
  if (option.key === key) {
    return true;
  }
  return !!option.child?.find(item => isKeyExistInOption(item, key));
}

export function isPathExistInOption(option: NavOptionType, path: string): boolean {
  if (option.path === path) {
    return true;
  }
  return !!option.child?.find(item => isPathExistInOption(item, path));
}

export function hasActiveOption(option: NavOptionType): boolean {
  if (option.active) {
    return true;
  }
  return !!option.child?.find(item => hasActiveOption(item));
}

export function isItemActiveBasedOnLocation(
  option: NavOptionType,
  location: Location,
  searchParams: URLSearchParams
): boolean {
  if (option.param && searchParams.get("filter") === option.param) {
    return true;
  } else if (option.param?.toLowerCase() === ALL_FILTER_KEY.toLowerCase() && !searchParams.get("filter")) {
    return true;
  }
  if (option.child) {
    return Boolean(option.child.find(item => isItemActiveBasedOnLocation(item, location, searchParams)));
  }
  const optionPath = option.path?.startsWith("/") ? option.path : `/${option.path}`;
  return !!(!option.child && option.path && location.pathname.endsWith(optionPath));
}

export function parseActiveItemFromLocation(optionsList?: Array<NavOptionType>, location?: Location) {
  if (!optionsList || !location) {
    return;
  }
  const pathArr = location.pathname.split("/");
  let activeOption;
  pathArr.reverse().find(path => {
    activeOption = optionsList.find(option => {
      if (option.child) {
        return Boolean(parseActiveItemFromLocation(option.child, location));
      } else {
        return option.path === path;
      }
    });
    return Boolean(activeOption);
  });
  return activeOption;
}

export function getFilteredNavOptionByAuthority(navOption: NavOptionType, hasAnyAuthority: Function) {
  return getFilteredNavOptionWithAuthority(navOption, hasAnyAuthority);
}

function getFilteredNavOptionWithAuthority(navOption: NavOptionType, hasAnyAuthority: Function): NavOptionType | null {
  const hasAuthority = !navOption.requiredAuthorities || hasAnyAuthority(navOption.requiredAuthorities);
  if (!hasAuthority) {
    return null;
  }
  return {
    ...navOption,
    child: navOption.child
      ?.map(o => getFilteredNavOptionWithAuthority(o, hasAnyAuthority))
      ?.filter(i => Boolean(i)) as Array<NavOptionType>
  };
}

export function isOptionAvailableInState({
  state,
  navOption
}: {
  state: NavigationProviderStateType;
  navOption: NavOptionType;
}) {
  const existAtIndex = [...state.navHistory, ...state.navFuture].findIndex(item => item.key === navOption.key);
  return existAtIndex > -1;
}
